import { InjectionToken } from '@angular/core';

export const CURRENT_PREVIEW_FILE = new InjectionToken<any>('CURRENT_PREVIEW_FILE');
